(function () {
    const embeds = document.querySelectorAll(".embeds.hasimg")
    for (let i = 0; i < embeds.length; i++) {
        embeds[i].addEventListener("mouseover", (e) => {
            e.preventDefault
            if (embeds[i].innerHTML.trim() == "") {
                embeds[i].innerHTML = embeds[i].dataset.html
            }
        })
    }

})();